<template>
  <div class="home_layout">
    <div class="home_body">
      <div class="home_body_top">
        <img
            class="home_body_top_banner"
            :src="!isConditionA
      ? require('@/static/images/vip_discounts/home37.png')
      : require('@/static/images/vip_discounts/home_banner.png')"
            alt=""
        >
        <div class="home_body_top_btn_wrap">
          <div class="home_body_top_btn" @click="getEquityClick">
            <p>权益说明</p>
          </div>
          <div class="home_body_top_btn" @click="getRecordsClick">
            <p>领取记录</p>
          </div>
        </div>
      </div>
      <div class="home_body_middle_btnlayout_chancebtn">
        <template v-if="!dataLoaded">
          <!-- 加载中状态 -->
          <div class="loading-placeholder"></div>
        </template>
        <template v-else>
          <template v-if="saleStrategyNoList.length > 0">
            <span>您有</span>
            <span class="home_body_middle_btnlayout_chancebtn_count">{{ count }}</span>
            <span>次领取的机会</span>
          </template>
          <span v-else class="unsubscribed-text">未订购或已退订</span>
        </template>
      </div>
      <div class="account">
        <img class="account_img" src="@/static/images/vip_discounts/section_top.png"/>
        <div class="account_info"><span>账户</span>{{ userInfo.mobile | mobileFilter }}</div>
      </div>
      <div class="home_body_middle">
        <!-- 修复：错误的 divibase-service.jar 标签改为 div -->
        <div
            class="home_body_middle_btnlayout"
            v-if="this.regionNo != '37' && this.regionNo === '31' && this.mealAmount === 30">
          <div class="text_title" v-if="this.regionNo != '37' && this.regionNo === '31' && this.mealAmount === 30">
            <div>1 点击激活，立刻到账</div>
          </div>
        </div>

        <!-- 修复：错误的 divibase-service.jar 标签改为 div -->
        <div
            class="home_body_middle_btnlayout"
            v-if="this.regionNo != '37' && this.regionNo === '31' && this.mealAmount === 0">
          <div class="text_title" v-if="this.regionNo != '37' && this.regionNo === '31' && this.mealAmount === 0">
            <div>1 点击激活，立刻到账</div>
          </div>
        </div>

        <!-- 河南带中粮-->
        <div
            class="home_body_middle_btnlayout"
            v-if="this.regionNo === '41'">
          <div class="text_title" v-if="this.regionNo === '41'">
            <div>1 点击激活，立刻到账</div>
          </div>
        </div>
        <DiscountItem
            v-if="this.regionNo === '37'"
            :dataList="dataList"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"
            @showStockMsg="showStockMsg"/>
        <DiscountItem
            v-if="this.regionNo === '31' && this.mealAmount === 30"
            :dataList="dataLister"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"
            @showStockMsg="showStockMsg"/>
        <div class="text_title" v-if="this.regionNo === '31' && this.mealAmount === 30">
          <div>2 任选2张10元，点击去使用兑换</div>
        </div>

        <DiscountItem
            v-if="this.regionNo === '31' && this.mealAmount === 0"
            :dataList="dataLister"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"
            @showStockMsg="showStockMsg"/>
        <div class="text_title" v-if="this.regionNo === '31' && this.mealAmount === 0">
          <div>2 任选2张10元，点击去使用兑换</div>
        </div>
        <DiscountItem
            v-if="this.regionNo === '31'"
            :dataList="dataList"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"
            @showStockMsg="showStockMsg"/>
        <DiscountItem
            v-if="this.regionNo === '41'"
            :dataList="dataLister"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"
            @showStockMsg="showStockMsg"
        />

        <div class="text_title" v-if="this.regionNo == '41' && this.mealAmount == 20">
          <div>2 两种超市卡二选一，点击去使用完成选择</div>
        </div>
        <div class="text_title" v-if="this.regionNo == '41' && this.mealAmount != 20">
          <div>2 两张10元超市卡，三种组合方式任选一种，点击去使用兑换</div>
        </div>

        <DiscountItem
            v-if="this.regionNo === '41'"
            :dataList="dataList"
            :regionNo="regionNo"
            :count="count"
            @showMsg="showMsgBtnClick"/>
      </div>
      <div class="customer-service">
        <span>客服热线</span>
        <a href="tel:4001797997">4001-7979-97</a>
      </div>
      <div class="home_body_footer">
        <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2023042110号-1</a>
      </div>
      <modal :visible="popupVisible" title="登录账号" :isCancelBtn="true" @onCancel="cancelModalClick">
        <template #modal_body>
          <mt-field class="home_login_modal_input" placeholder="请输入手机号" v-model="phoneNum" type="tel"></mt-field>
          <mt-field class="home_login_modal_input" placeholder="请输入验证码" v-model="verificationCode">
            <div v-if="nexttime === 59" class="home_login_modal_extra" @click="getcode"> 获取验证码</div>
            <div v-else class="home_login_modal_extra_disabled">
              <span>{{ nexttime }}</span>
              <span>s后重新获取</span>
            </div>
          </mt-field>
          <div class="home_login_modal_btn" @click.stop="loginBtnClick"> 登录</div>
        </template>
      </modal>
      <modal
          :visible="msgPopupVisible"
          title="温馨提示"
          :isCancelBtn="true"
          @onCancel="msgBtnClick"
          class="home_msg_modal">
        <template #modal_body>
          <p class="home_msg_modal_content">您未订购本权益，暂无法使用</p>
          <div class="home_login_modal_btn" @click.stop="msgBtnClick"> 知道了</div>
        </template>
      </modal>
      <modal
          :visible="stockPopupVisible"
          title="温馨提示"
          :isCancelBtn="true"
          @onCancel="closeStockMsg"
          class="home_msg_modal">
        <template #modal_body>
          <p class="home_msg_modal_content">领取太火爆，正在加急补货</p>
          <div class="home_login_modal_btn" @click.stop="closeStockMsg"> 知道了</div>
        </template>
      </modal>
      <!-- 【全新】公告弹窗 - 永远不会溢出 -->
      <div class="notice-mask" v-show="noticePopupVisible">
        <div class="notice-box">
          <div class="notice-title">{{ noticeTitle }}</div>
          <div class="notice-content" v-html="noticeContent"></div>
          <div class="notice-btn" @click="closeNoticeModal">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import modal from '../../components/modal.vue'
import {mapMutations, mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'
import {isMobileDevice, isMobileOnlyEnabled} from '@/static/js/device'
import DiscountItem from './components/DiscountItem.vue'

export default {
  ...mapMutations(['setLoginInfo', 'setToken']),
  components: {
    modal,
    DiscountItem
  },
  data() {
    return {
      mealAmount: '',
      regionNo: '',
      saleStrategyNoList: [],
      count: 0,
      dataList: [],
      dataLister: [],
      popupVisible: false,
      phoneNum: '',
      verificationCode: '',
      nexttime: 59,
      isNeedLogin: true,
      timeInterval: null,
      msgPopupVisible: false,
      flag: false,
      dataLoaded: false, // 新增：数据加载状态
      stockPopupVisible: false,
      // 公告弹窗模板
      noticePopupVisible : false,
      noticeContent: '',
      noticeTitle: '【权益升级通知】', // 标题优化，更醒目
    }
  },
  created() {
    // 开关关闭时不限制设备，PC 本地调试无需再手动注释代码
    if (isMobileOnlyEnabled()) {
      this.getBrowser()
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(['loginInfo', 'token']),
    userInfo() {
      const vipLoginInfo = this.loginInfo || JSON.parse(localStorage.getItem('vipLoginInfo'))
      return vipLoginInfo
    },
    isConditionA() {
      return localStorage.getItem('regionNo')?.trim() === '37';
    }
  },
  filters: {
    useBtnTe(val) {
      switch (val) {
        case '0':
          return '去激活'

        case '1':
          return '已激活'
        default:
          return '已激活'
      }
    },
    useBtnText(val) {
      switch (val) {
        case '0':
          return '去使用'
        case '2':
          return '下月使用'
        case '1':
          return '已使用'
        default:
          return '下月使用'
      }
    },
    mobileFilter(val) {
      if (val) {
        const beforeContent = val.substring(0, 3)
        const afterContent = val.substring(val.length - 4, val.length)
        return beforeContent + '****' + afterContent
      } else {
        return ''
      }
    }
  },
  methods: {
    /** 翼支付授权 */
    getAuth() {
      const _this = this
      // eslint-disable-next-line no-undef
      BestpayHtml5.config()
      // eslint-disable-next-line no-undef
      BestpayHtml5.User.userAuth(
          {
            scope: 'mobile,user_info',
            clientId: '86003000355',
            redirectUrl: 'http://www.qq-card.com/dist/',
            merchantCode: '3178038398127215',
            state: new Date().getTime()
          },
          function (res) {
            // 用户点击授权弹框的确定按钮
            console.log('授权', res)
            let orderAmountFromUrl = _this.getOrderAmountFromUrl();
            var regionNoFromUrl = _this.getRegionNoFromUrl();
            console.log('orderAmountFromUrl', orderAmountFromUrl)
            console.log('regionNoFromUrl', regionNoFromUrl)
            const params = {
              authCode: res.code,
              grantType: res.grantType,
              orderAmount: orderAmountFromUrl,
              regionNo: regionNoFromUrl
            }
            _this.getPhone(params)
          }
      )
    },
    getOrderAmountFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('orderAmount');
    },
    getRegionNoFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('regionNo');
    },
    getImageSrc(regionNo) {
      const imagePath = `../../static/images/vip_discounts/${regionNo}.jpg`
      console.log(imagePath)
      return imagePath
    }
    ,
    /** 获取登录信息 */
    async getPhone(params) {
      this.dataLoaded = false; // 开始加载
      console.log('getPhone', params)
      try {
        await this.post(this.apis.getToken, params)
            .then((res) => {
              console.log('获取手机号', res)
              if (res.data.code === '0') {
                this.isNeedLogin = false
                const vipInfo = res.data.data
                this.saleStrategyNoList = res.data.data.saleStrategyNoList
                const token = res.headers.authorization
                this.$store.commit('setLoginInfo', vipInfo)
                this.$store.commit('setToken', token)
                this.$nextTick(() => {
                  this.getGoodsList()
                  console.log(111111)
                  this.getDiscountsCounts()
                  console.log(222222)
                })
              } else if (res.data.code === '9999') {
                this.$toast({
                  message: res.data.message,
                  duration: 1000
                })
              }
            })
            .catch((error) => {
              console.log(error)
            })
      } finally {
        this.dataLoaded = true; // 结束加载
      }
    }
    ,

    /** 非移动端时跳转到提示页 messagePage */
    getBrowser() {
      if (!isMobileDevice()) {
        this.$router.replace({
          name: 'messagePage',
          params: {}
        })
        this.flag = false
      } else {
        this.flag = true
      }
    }
    ,
    init() {
      // if(!this.flag){return}
      // const isRefresh = this.$route.params.isRefresh;
      // if (isRefresh) {
      //   this.isNeedLogin = true;
      //   this.popupVisible = true;
      // }
      const token = localStorage.getItem('token')
      const vipLoginInfo = localStorage.getItem('vipLoginInfo')
      // 判断登录状态 (缓存中是否有token信息)
      if (token) {
        this.isNeedLogin = false
        this.$store.commit('setLoginInfo', JSON.parse(vipLoginInfo))
        this.$store.commit('setToken', token)
        console.log(3333)
        this.getDiscountsCounts()
        this.getGoodsList()
      } else {
        console.log(44444)
        this.getGoodsList()
      }
      this.$nextTick(() => {
        this.getAuth()
      })
    }
    ,
    /** 查询商品列表 */
    getGoodsList() {
      console.log(555555)
      localStorage.clear()
      this.post(this.apis.findGoodsList, {
        memberId: this.loginInfo.id || '',
        saleStrategyNoList: this.saleStrategyNoList
      })
          .then((res) => {
            console.log(6666666666)
            this.dataList = []
            this.dataLister = []
            console.log('555', res)
            if (res.data.code === '0') {
              let data = res.data.data.productCatalogList
              this.regionNo = res.data.data.regionNo
              console.log('获取到的区域号放入缓存' + this.regionNo)
              localStorage.setItem('regionNo', this.regionNo)
              this.displayMode = res.data.data.displayMode
              console.log('获取到的展示模式' + this.displayMode)
              localStorage.setItem('displayMode', this.displayMode)
              console.log('获取到的会员id放入缓存' + this.loginInfo.id)
              localStorage.setItem('memberId', this.loginInfo.id)
              this.mealAmount = res.data.data.mealAmount
              if (this.regionNo == '37') {
                data = data.map((item) => {
                  return {
                    id: item.id,
                    amounts: item.cardAmount,
                    count: item.cardNum,
                    picUrl: item.picUrl,
                    title: item.goodsName,
                    content: '每月特权 会员专享',
                    useState: item.useStatus.toString(),
                    couponId: item.couponId,
                    goodsType: item.goodsType
                  }
                })
                this.dataList = data
              } else {
                data = data.map((item) => {
                  let temp = {
                    id: item.id,
                    amounts: item.cardAmount,
                    count: item.cardNum,
                    picUrl: item.picUrl,
                    title: item.goodsName,
                    content: '每月特权 会员专享',
                    useState: item.useStatus.toString(),
                    couponId: item.couponId,
                    goodsType: item.goodsType
                  }

                  if (item.goodsType == '1') {
                    this.dataLister.push(temp)
                  } else {
                    this.dataList.push(temp)
                  }
                })
              }

              // =============== 修复：区域加载完成后再显示弹窗 ===============
              this.showNoticeModal();
            }
          })
          .catch((error) => {
            console.log(error)
          })
    }
    ,

    /** 获取权益次数 */
    async getDiscountsCounts() {
      this.dataLoaded = false; // 开始加载
      localStorage.setItem('spn', this.saleStrategyNoList[0])
      try {
        const params = {
          memberId: this.loginInfo.id,
          saleStrategyNoList: this.saleStrategyNoList
        }
        this.post(this.apis.findRightsCount, params)
            .then((res) => {
              if (res.data.code === '0') {
                this.count = res.data.data
                localStorage.setItem('cardCount', this.count)
              }
            })
            .catch((error) => {
              handleRequestError(this, error, () => {
                // this.isNeedLogin = true;
                // this.popupVisible = true;
              })
            })
      } finally {
        this.dataLoaded = true; // 结束加载
      }
    },
    showStockMsg() {
      this.stockPopupVisible = true;
    },
    closeStockMsg() {
      this.stockPopupVisible = false;
    }
    ,
    /** 查看领取记录 */
    getRecordsClick() {
      // if (this.isNeedLogin) {
      //   this.popupVisible = true;
      //   return;
      // }
      this.$router.push({
        name: 'couponRecords',
        params: {
          memberId: this.loginInfo.id
        }
      })
    }
    ,
    /** 查看权益说明 */
    getEquityClick() {
      this.$router.push({
        name: 'equity'
      })
    }
    ,
    /** 登录*/
    toLoginClick() {
      // this.popupVisible = true;
    }
    ,
    /** 退出登录 */
    toExitClick() {
      console.log('点击退出')
      this.exit()
    }
    ,
    /** 查看详情 */
    toDetailClick(item) {
      // if (this.isNeedLogin) {
      //   this.popupVisible = true;
      //   return;
      // }
      this.$router.push({
        name: 'discountsDetail',
        params: {
          id: item.id,
          num: item.count,
          regionNo: this.regionNo,
          goodsType: item.goodsType
        }
      })
      console.log('存入卡id' + item.id)
      localStorage.setItem('goodsId', item.id)
    }
    ,
    /** 去使用 */
    toUseClick(item) {
      console.log('333', item)
      console.log(item, this.count)
      // if (this.isNeedLogin) {
      //   this.popupVisible = true;
      //   return;
      // }
      // 已使用
      if (item.useState === '1') {
        return
      }
      // 0次选择机会｜下月使用
      if (item.goodsType == 1) {
        this.$router.push({
          name: 'discountsDetail',
          params: {
            id: item.id,
            outCouponId: item.couponId,
            num: item.count,
            regionNo: this.regionNo,
            goodsType: item.goodsType
          }
        })

      } else {
        if ((item.useState === '0' && this.count === 0) || item.useState === '2') {
          this.msgPopupVisible = true
        } else {
          this.$router.push({
            name: 'discountsDetail',
            params: {
              id: item.id,
              outCouponId: item.couponId,
              num: item.count,
              regionNo: this.regionNo,
              goodsType: item.goodsType
            }
          })
        }
      }
      console.log('去使用存入卡id' + item.id)
      localStorage.setItem('goodsId', item.id)

    }
    ,
    /** 关闭提示信息对话框 */
    msgBtnClick() {
      this.msgPopupVisible = false
    }
    ,
    showMsgBtnClick() {
      this.msgPopupVisible = true
    }
    ,
    /** 点击获取验证码 */
    getcode() {
      const check = /^[1][3,4,5,6,7,8,9][0-]{9}$/
      if (!check.test(this.phoneNum)) {
        this.$toast({
          message: '请输入正确的手机号',
          duration: 1000
        })
      } else {
        this.sendCode()
        this.timeInterval = setInterval(() => {
          if (this.nexttime === 0) {
            this.nexttime = 59
            clearInterval(this.timeInterval)
          } else {
            this.nexttime -= 1
          }
        }, 1000)
      }
    }
    ,
    /** 确认登录 */
    loginBtnClick() {
      if (this.phoneNum === '') {
        this.$toast({
          message: '手机号不能为空',
          duration: 1000
        })
      } else if (this.verificationCode === '') {
        this.$toast({
          message: '验证码不能为空',
          duration: 1000
        })
      } else {
        this.login()
      }
    }
    ,
    /** 关闭登录窗口 */
    cancelModalClick() {
      this.phoneNum = ''
      this.verificationCode = ''
      if (this.timeInterval) {
        this.nexttime = 59
        clearInterval(this.timeInterval)
      }
      this.popupVisible = false
    }
    ,
    /** 获取登录信息 */
    login() {
      this.post(this.apis.login, {
        phone: this.phoneNum,
        code: this.verificationCode
      })
          .then((res) => {
            if (res.data.code === '0') {
              this.isNeedLogin = false
              const vipInfo = res.data.data
              const token = res.headers.authorization
              this.$store.commit('setLoginInfo', vipInfo)
              this.$store.commit('setToken', token)
              this.$toast({
                message: '登录成功',
                duration: 1000
              })
              this.cancelModalClick()
              this.$nextTick(() => {
                this.getGoodsList()

                this.getDiscountsCounts()
              })
            } else if (res.data.code === '9999') {
              this.$toast({
                message: res.data.message,
                duration: 1000
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
    }
    ,
    /** 获取验证码 */
    sendCode() {
      this.post(this.apis.getIdentifyingCode, {
        mobile: this.phoneNum
      })
          .then((res) => {
            if (res.data.code === '9999') {
              this.$toast({
                message: '发送成功',
                duration: 1000
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
    }
    ,
    /** 退出 */
    exit() {
      this.post(this.apis.exitLogin)
          .then((res) => {
            if (res.data.code === '0') {
              this.$toast({
                message: '退出成功',
                duration: 1000
              })
              localStorage.clear()
              this.isNeedLogin = true
              this.count = '-'
              this.getGoodsList()
            } else if (res.data.code === '9999') {
              this.$toast({
                message: res.data.message,
                duration: 1000
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },
    // 关闭公告弹窗
    closeNoticeModal() {
      this.noticePopupVisible = false;
      // 可选：标记已读，避免重复弹窗（根据需求开启）
      localStorage.setItem(this.getNoticeStorageKey(), 'true');
    },

    getNoticeStorageKey(region) {
      const currentRegion = region || this.regionNo || localStorage.getItem('regionNo') || '';
      const noticeVersionMap = {
        '37': '2026-05-13'
      };
      const noticeVersion = noticeVersionMap[currentRegion];
      return noticeVersion
          ? `hasReadHomeNotice_${currentRegion}_${noticeVersion}`
          : 'hasReadHomeNotice';
    },

    // 显示公告弹窗（封装成方法，方便调用）
    showNoticeModal() {
      // 优先从缓存拿区域
      const region = this.regionNo || localStorage.getItem('regionNo');

      // 河南(41) 不显示弹窗
      if (region === '41') {
        this.noticePopupVisible = false;
        return;
      }

      // 山东(37) 公告内容
      if (region === '37') {
        this.noticeTitle = '关于权益平台领取规则升级优化的公告';
        this.noticeContent = `
<div>尊敬的用户：</div>
<div style="text-indent:2em;">为进一步维护健康的权益平台生态，防范和规避恶意套取、倒卖权益的行为，2026年11月1日平台将对权益的领取规则升级优化，相关说明如下：</div>
<div style="text-indent:2em;">1、权益领取后，相应优惠券将直充至“订购权益包的手机号码”所注册或绑定的客户端账户中；如领取京东e卡，将直充至“订购权益包的手机号码”注册的京东账户【注：平台无法再充值至“非订购手机号码”注册的京东账户】。</div>
<div style="text-indent:2em;">2、领取权益前，请确认“订购权益包的手机号码”是否注册拟领取权益的客户端账户，如未注册，请先注册账户后再领取权益。</div>
<div style="text-indent:2em;">3、如“订购权益包的手机号码”不便注册拟领权益的客户端账户，或本规则升级后已无使用需求，请于2026年10月31日前退订权益包，避免次月产生费用，造成损失。具体退订方式请咨询客服电话10000。</div>
<div style="text-indent:2em;">给您带来不便，还请谅解！如有疑问请联系翼支付在线客服，感谢您的理解与支持，祝您生活愉快！</div>
<div style="text-align:right;margin-top:10px;">翼支付权益运营团队</div>
<div style="text-align:right;">2026年10月15日</div>
`;
      }

      // 上海(31) 公告内容
      else if (region === '31') {
        this.noticeTitle = '【权益升级通知】';
        this.noticeContent = `
<div>尊敬的用户：</div>
<div style="text-indent:2em;">为进一步优化权益的使用体验，自2026年4月1日起平台将进一步优化权益领用方式和更换部分领用少的权益：</div>
<div style="text-indent:2em;">1、“沃尔玛电子券”的领用方式由原来‘卡密兑换’升级为‘账户直充’方式，确认领取后电子券将直充至您指定的账户；</div>
<div style="text-indent:2em;">2、原“大润发、叮咚买菜电子券”正式下线，新增“唯品会、屈臣氏电子券”，确认领取后直充至指定账户，便捷使用。</div>
<div style="text-indent:2em;">敬请知悉，感谢您的支持！如有疑问，请咨询客服4001-7979-97。</div>
<div style="text-align:right;margin-top:10px;">惠享网购权益平台</div>
<div style="text-align:right;">2026年3月18日</div>
`;
      } else {
        // 其他地区不弹
        this.noticePopupVisible = false;
        return;
      }

      // 已读检查
      const hasRead = localStorage.getItem(this.getNoticeStorageKey(region));
      if (!hasRead) {
        setTimeout(() => {
          this.noticePopupVisible = true;
        }, 800);
      }
    }
  }
}
</script>
<style scoped lang="less">
.home_layout {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  /* 标准的语法（必须放在最后） */
  position: relative;
  max-width: 750px;
  margin: 0 auto;
}

.text_title {
  margin: 24px 24px 0 24px;
  padding: 0px 16px;
  color: #db6942;
  font-weight: bold;
}

.home_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 50px;

  &_top {
    width: 100%;
    // min-height: 300px;
    // object-fit: cover;
    overflow: hidden;
    position: relative;

    &_banner {
      width: 100%;
      object-fit: cover;
      display: block;
    }

    &_btn_wrap {
      position: absolute;
      top: 30px;
      right: -2px;
    }

    &_btn {
      width: 138px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: #f4b8ad;
      border-radius: 36px 0px 0px 36px;
      border: 2px solid #ffded1;
      color: #8a3939;
      font-size: 24px;
      margin-bottom: 16px;
      opacity: 0.8;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: calc(50% + 4px);
      height: 28px;
      background: #fff;
      border-radius: 28px 28px 0 0;
    }

    &::after {
      right: 0;
    }
  }

  &_middle {
    max-width: 700px;
    margin: 24px;
    margin-top: 0;
    border: 2px solid #ffeee4;
    border-top: 2px solid transparent;
    border-radius: 0 0 24px 24px;
    // background: #fdf1f1;
    min-height: 300px;
    position: relative;
    z-index: 1;

    &_btnlayout {
      // margin-top: -50px;
      padding-bottom: 16px;

      &_titlebtn {
        margin: 0 auto;
        border: 10px solid #eb9e5e;
        border-radius: 60px;
        line-height: 76px;
        text-align: center;
        box-shadow: 15px 8px 20px -18px #8c8c8c;
        font-size: 25px;
        width: 50%;
        font-weight: bold;
        background: -webkit-linear-gradient(#fbedc3, #f6d690);
        /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#fbedc3, #f6d690);
        /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#fbedc3, #f6d690);
        /* Firefox 3.6 - 15 */
        background: linear-gradient(#fbedc3, #f6d690);

        /* 标准的语法（必须放在最后） */

        &_lefttext {
          text-shadow: 1px 1px #f4a67a;
          margin-right: 16px;
        }

        &_righttext {
          color: #e44949;
          text-shadow: 1px 1px #f4a67a;
        }
      }

      &_chancebtn {
        font-size: 28px;
        margin: 44px 0 36px 0;
        font-weight: bold;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &::before,
        &::after {
          content: '';
          width: 80px;
          height: 2px;
          background: #f5f5f5;
          display: inline-block;
        }

        &::after {
          margin-left: 20px;
        }

        &::before {
          margin-right: 20px;
        }

        &_count {
          color: #f15757;
          font-size: 48px;
          margin: 0 16px;
        }
      }

      &_loginbtn {
        background: #e44949;
        width: 180px;
        text-align: center;
        padding: 8px 16px;
        border-radius: 20px;
        color: #fff;
        margin: 0 auto;
        background: -webkit-linear-gradient(#fc6e6e, #c20202);
        /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#fc6e6e, #c20202);
        /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#fc6e6e, #c20202);
        /* Firefox 3.6 - 15 */
        background: linear-gradient(#fc6e6e, #c20202);
        /* 标准的语法（必须放在最后） */
      }

      &_exitbtn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 32px;
        background: #ffd8d8;
        border-radius: 32px;
        margin: 8px 48px;
        box-shadow: 0px 2px 4px 0px #ca82824f;

        &_phone {
          color: #5e5e5e;
          font-size: 24px;
        }

        &_btn {
          color: #f83b0a;
          text-decoration: underline solid #f83b0a;
          font-size: 26px;
        }
      }
    }

    &_discounts {
      &_items {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 32px 32px 32px;
        background-image: url(../../static/images/vip_discounts/coupon.png);
        background-repeat: no-repeat;
        background-size: 100%;
        height: 200px;
        padding: 0px 16px;

        &_left {
          padding: 8px 8px;
          position: relative;
          width: 150px;

          &_count {
            position: absolute;
            top: 8px;
            right: 0;
            font-size: 14px;
            color: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            padding: 4px 8px;
            width: fit-content;
            background: -webkit-linear-gradient(#fe8862, #e42c00);
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(#fe8862, #e42c00);
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(#fe8862, #e42c00);
            /* Firefox 3.6 - 15 */
            background: linear-gradient(#fe8862, #e42c00);
            /* 标准的语法（必须放在最后） */
          }

          &_amount {
            font-size: 90px;
            font-weight: bold;
            color: #f83b0a;
            word-spacing: -20px;

            &_extra {
              font-size: 30px;
              font-weight: normal;
            }
          }
        }

        &_middle {
          width: 230px;
          padding: 16px;

          &_title {
            font-size: 31px;
            font-weight: bold;
            margin-bottom: 8px;
          }

          &_content {
            font-size: 24px;
            color: #8c8c8c;
          }
        }

        &_right {
          font-size: 24px;

          &_touse {
            padding: 8px 16px;
            text-align: center;
            border-radius: 40px;
            color: #e04617;
            background: -webkit-linear-gradient(#fffdfc, #ffcdbf);
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(#fffdfc, #ffcdbf);
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(#fffdfc, #ffcdbf);
            /* Firefox 3.6 - 15 */
            background: linear-gradient(#fffdfc, #ffcdbf);
            /* 标准的语法（必须放在最后） */
          }

          &_disabled {
            padding: 8px 16px;
            text-align: center;
            border-radius: 40px;
            color: #fff;
            background: #d8d8d8;
          }
        }
      }
    }
  }

  &_footer {
    text-align: center;
    position: absolute;
    bottom: 16px;
    width: 100%;

    a {
      color: #333;
      text-decoration: none;
    }
  }

  .account {
    margin: 0 24px;
    max-width: 704px;
    position: relative;

    .account_img {
      width: 100%;
      display: block;
    }

    .account_info {
      position: absolute;
      height: 100%;
      top: 0;
      left: 58px;
      color: #985050;
      font-size: 28px;
      display: flex;
      align-items: center;

      span {
        margin-right: 12px;
      }
    }
  }
}

.home_login {
  &_modal {
    width: 60%;
    padding: 16px 24px;
    border-radius: 24px;
    height: 400px;

    &_title {
      width: 100%;
      font-size: 30px;
      color: #090606;
      text-align: center;
      font-weight: bold;
      padding-top: 40px;
    }

    &_input {
      border: 1px solid #eeeeee;
      border-radius: 24px;
      margin: 24px 0px;
      height: 76px;
      line-height: 76px;

      /deep/ .mint-field-core {
        font-size: 24px;
      }

      /deep/ .mintui-field-error {
        font-size: 24px;
      }

      &_error {
        color: #cd0c09;
        font-size: 18px;
      }
    }

    &_extra {
      color: #cd0c09;
      cursor: pointer;
      font-size: 24px;
      padding-left: 8px;

      &_disabled {
        color: #b9b9b9;
        font-size: 20px;
      }
    }

    &_btn {
      width: 85%;
      margin: 0 auto;
      background-color: #cd0c09;
      border-radius: 40px;
      height: 60px;
      text-align: center;
      color: #fff;
      line-height: 60px;
      margin-top: 24px;
      margin-top: 40px;
      font-size: 24px;
    }

    &_cancel {
      width: 56px;
      height: 56px;
      margin: 0 auto;
      margin-top: 150px;
    }
  }
}

.home_msg {
  &_modal {
    height: 300px;
    min-height: 300px;

    &_content {
      text-align: center;
      margin: 24px 0px;
    }
  }
}

.loading-placeholder {
  width: 200px;
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin: 0 auto;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.unsubscribed-text {
  color: #999;
}

.customer-service {
  background: url('~@/static/images/vip_discounts/service_bg.png') no-repeat;
  background-size: cover;
  width: 488px;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
  margin-bottom: 54px;
  font-size: 28px;

  span {
    margin-right: 12px;
    padding-left: 100px;
  }

  a {
    font-size: 32px;
    text-decoration: none;
    color: #000;
    font-weight: bold;
  }
}

/* -------------- 最终完美弹窗 缩进/换行/不溢出全部正常 -------------- */
.notice-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999 !important;
}

.notice-box {
  width: 82%;
  max-width: 600px;
  background: #fff;
  border-radius: 20px;
  padding: 25px;
  box-sizing: border-box;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
}

.notice-title {
  font-size: 28px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

/* 核心：正常解析 HTML 标签，保留所有排版 */
.notice-content {
  flex: 1;
  overflow-y: auto;
  font-size: 26px;
  line-height: 1.7;
  color: #333;
  padding-right: 8px;

  /* 下面这行是关键：恢复 HTML 排版 */
  white-space: normal !important;

  p {
    margin: 0 0 12px 0 !important;
    line-height: 1.6 !important;
  }
  .indent {
    text-indent: 2em !important;
  }
  .signature {
    text-align: right !important;
    margin-top: 10px !important;
  }
}

.notice-content::-webkit-scrollbar {
  width: 4px;
}
.notice-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

.notice-btn {
  margin-top: 20px;
  background: #cd0c09;
  color: #fff;
  text-align: center;
  height: 60px;
  line-height: 60px;
  border-radius: 30px;
  font-size: 24px;
}
</style>
